import { render, staticRenderFns } from "./ChartReferralPhaseCategory.vue?vue&type=template&id=3e1b1cc9&"
import script from "./ChartReferralPhaseCategory.vue?vue&type=script&lang=ts&"
export * from "./ChartReferralPhaseCategory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports